// Simple cache utility with expiration
// I don't think it is storing data in cookies or local storage

const CACHE_DURATION = 60 * 1000; // 1 minute in milliseconds

class CacheService {
   constructor(name) {
      this.name = name;
      this.cache = null;
      this.lastFetchTime = null;
   }

   // Store data in cache
   setData(data) {
      this.cache = data;
      this.lastFetchTime = Date.now();
      console.log(
         `🔵 ${this.name} Cache: Data stored in cache at`,
         new Date(this.lastFetchTime).toLocaleTimeString()
      );
   }

   // Get data if not expired
   getData() {
      if (!this.cache || !this.lastFetchTime) {
         console.log(`🔴 ${this.name} Cache: No cached data available`);
         return null;
      }

      const timeSinceLastFetch = Date.now() - this.lastFetchTime;
      const isExpired = timeSinceLastFetch > CACHE_DURATION;

      if (isExpired) {
         console.log(
            `🟡 ${this.name} Cache: Data expired. Time since last fetch:`,
            Math.round(timeSinceLastFetch / 1000),
            "seconds"
         );
         return null;
      }

      console.log(
         `🟢 ${this.name} Cache: Returning cached data. Age:`,
         Math.round(timeSinceLastFetch / 1000),
         "seconds"
      );
      return this.cache;
   }

   // Check if cache needs refresh
   needsRefresh() {
      const needsRefresh = !this.lastFetchTime || Date.now() - this.lastFetchTime > CACHE_DURATION;
      if (needsRefresh) {
         console.log(`🔄 ${this.name} Cache: Data needs refresh`);
      }
      return needsRefresh;
   }

   // Clear cache
   clearCache() {
      this.cache = null;
      this.lastFetchTime = null;
      console.log(`🗑️ ${this.name} Cache: Cache cleared`);
   }
}

// Create singleton instances
export const dashboardCache = new CacheService("Dashboard");
export const formsCache = new CacheService("Forms");
